import { getUrl, Request } from '../../request';

export const postFirebase = (device_token, operating_system, user_agent, city_id) =>
  Request.post(getUrl('/api/v1/messaging/firebase/'), {
    device_token,
    operating_system,
    user_agent,
    city_id
  });
